import { msalInstance, loginRequestConfig } from 'config/auth';
import {oktaAuth} from 'config/oktaAuth';
import { AUTH } from 'constants/authConstants';
import AppService from 'services/app.service';
import { oidcConfig, signOut } from './../config/oidcAuth';
import { UserManager } from "oidc-client-ts";
import { jwtDecode } from 'jwt-decode';

export const getAccessToken = async () => {
  if(!AppService.isAuthenticatedByAzure() && !AppService.isAuthenticatedByOidc()) {
    return getIdTokenFromOkta();
  }
  if (AppService.isAuthenticatedByAzure()) {
    try {
      let currentToken = localStorage.getItem(AUTH.API_TOKEN);
      const tokenObj = !!currentToken ? JSON.parse(currentToken):{};
      if (!!tokenObj.expiresOn && (new Date().getTime() < tokenObj.expiresOn)) {
        return tokenObj?.token ? tokenObj?.token: undefined;
      } else {
        await msalInstance?.handleRedirectPromise();
        const [account] = msalInstance?.getAllAccounts();
        return !!account ? msalInstance?.acquireTokenSilent({
            ...loginRequestConfig,
            account,
          })
          .then((e: any) => {
            localStorage.setItem(AUTH.API_TOKEN, JSON.stringify({
              token: e.accessToken,
              expiresOn: Date.parse(e.expiresOn)
            }));
            return e.accessToken;
          }) : undefined;
      }
    } catch (e) {
      return undefined;
    };
  }
  if (AppService.isAuthenticatedByOidc()) {
    const currentUser = localStorage.getItem(AUTH.CURRENT_USER);
    const tokenData  = currentUser ? JSON.parse(currentUser) : {};
    const userManager = new UserManager({...oidcConfig});
    if(tokenData?.idToken){
      let tokenUser = jwtDecode(tokenData.idToken);
      if(tokenUser?.exp !== tokenData?.expiresAt){
        tokenData.expiresAt = tokenUser?.exp;
        localStorage.setItem(AUTH.CURRENT_USER, JSON.stringify(tokenData));
      }
    }
   
    if (!tokenData.idToken || isTokenExpired(tokenData)) {
        return userManager.signinSilent().then((data:any) => {
          if(data && data.id_token) {
            const userProfile = data.profile;
            const updatedUser =  {
              ...tokenData,
              idToken: data.id_token,
              expiresAt: data.expires_at,
              email: userProfile.email,
              username: userProfile.preferred_username
            };
            localStorage.setItem(AUTH.CURRENT_USER, JSON.stringify(updatedUser));
            return data.id_token;
          }
        }).catch((error: any)=>{
          console.error("Cannot refreh token, need to signout", error);
          signOut();
        });
    }
      
    return tokenData?.idToken;
  }
};


let refreshRequest: any = null;

export const getIdTokenFromOkta = async (): Promise<any> => {
  const storageItem = localStorage.getItem(AUTH.OKTA_TOKEN);
  const { idToken: savedToken = '' } = !!storageItem ? JSON.parse(storageItem) : {};

  if (!savedToken || isTokenExpired(savedToken)) {
    refreshRequest = refreshRequest ? refreshRequest : refreshToken();
    const { accessToken, idToken } = await refreshRequest;

    if (!idToken) {
      refreshRequest = null;
      return undefined;
    } else {
      localStorage.setItem(AUTH.OKTA_TOKEN, JSON.stringify({accessToken, idToken}));
      refreshRequest = null;
      return idToken.idToken;
    }
  } else {
    return savedToken.idToken;
  }
};

export const refreshToken = async () => {
  return oktaAuth?.token?.renewTokens();
};

const isTokenExpired = (token: any) => {
  return !!token ? token.expiresAt * 1000 <= Date.now() : false;
};